import React, { useEffect, useState } from "react";
import { Logo } from "../../constant/Index";
import "../../assets/Css/forgot.css";
import { clearMessage, setSuccess } from "../../store/reducers/globalReducers";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { useForm } from "../../hooks/Form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useUserChangePassMutation } from "../../store/services/AuthServices";

const CreateNewPassword = () => {
	const [errors, setErrors] = useState([]);
	const { state, onChange } = useForm({
		password: "",
		confirm_password: "",
	});
	let token1 = window?.location?.search?.split("?token=")[1];
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { success } = useSelector((state) => state.globalReducer);

	const [userResetpass, response] = useUserChangePassMutation();

	const onSubmit = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("password", state.password);
		FormDatas.append("confirm_password", state.confirm_password);
		FormDatas.append("reset_token", token1);
		userResetpass(FormDatas);
	};

	useEffect(() => {
		if (success !== "") {
			ToastMessage(success);
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			dispatch(setSuccess(response?.data?.message));
			state.password = "";
			state.confirm_password = "";
			setTimeout(() => {
				navigate("/login");
			}, 1000);
		}
	}, [response.isSuccess]);
	return (
		<>
			{/* <!-- Sign In Page Start Here --> */}
			<section className="signinSec p-0 d-flex align-items-center creat_password">
				<div className="container-fluid">
					<div className="row align-items-center">
						<div className="col-lg-4"></div>
						<div className="col-lg-4 p-0 pb-5 mb-5">
							<div className="logo-wrapper">
								<figure>
									<img src={Logo} alt="" />
								</figure>
							</div>
							<div className="signInBox">
								<div className="title">
									<h1>Create New Password</h1>
								</div>

								<div className="taglines pb-3">
									<h3>Type & confirm a strong & secure new Password</h3>
								</div>
								<form onSubmit={onSubmit}>
									<div className="form-group">
										<input
											type="password"
											className={`${
												errors && errors?.password
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											name="password"
											value={state.password}
											onChange={onChange}
											placeholder="New Password"
										/>
									</div>
									{errors && errors?.password && (
										<span className="errorMessage">
											<p>{errors && errors?.password}</p>
										</span>
									)}
									<div className="form-group">
										<input
											type="password"
											className={`${
												errors && errors?.confirm_password
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											name="confirm_password"
											value={state.confirm_password}
											onChange={onChange}
											placeholder="Confirm Password"
										/>
									</div>
									{errors && errors?.confirm_password && (
										<span className="errorMessage">
											<p>{errors && errors?.confirm_password}</p>
										</span>
									)}
									<div className="col-md-12 px-0 text-right mt-3">
										<button
											className="btn btn-secondary btnn signup-btn rounded-pill full"
											type="submit"
										>
											Submit
										</button>
									</div>
									<div className="privacyDv">
										<p>Copyrights © 2022 EVX. All rights reserved.</p>
									</div>
								</form>
							</div>
						</div>
						<div className="col-lg-4"></div>
					</div>
				</div>
			</section>
			{/* <!-- Sign In Page End Here --> */}
		</>
	);
};

export default CreateNewPassword;
